const mask = '# ### ### ## ##';
const formatPhone = (phone) => {
    const phoneDigitsArr = [...phone];
    const { outputPhone } = [...mask].reduce((acc, cur) => {
        if (!acc.restPhoneDigits.length)
            return acc;
        if (cur !== '#')
            return {
                ...acc,
                outputPhone: acc.outputPhone.concat(cur),
            };
        const [digit, ...restPhoneDigits] = acc.restPhoneDigits;
        return {
            restPhoneDigits,
            outputPhone: acc.outputPhone.concat(digit),
        };
    }, {
        restPhoneDigits: phoneDigitsArr,
        outputPhone: '',
    });
    return outputPhone;
};

export { formatPhone };
//# sourceMappingURL=formatPhone.js.map
